import styled, { css } from 'styled-components'
import { ZIndex } from '../../constants'
import { media } from '../../theme/breakpoints'

const selectedStyle = css`
    z-index: ${ZIndex.Table};
    position: relative;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);

    background-color: ${(p) => p.theme.colors.primary.green100};
    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-image: ${(p) =>
        `linear-gradient(${p.theme.colors.primary.green100}, ${p.theme.colors.primary.green100}), linear-gradient(90.89deg, ${p.theme.colors.primary.green100} 4.14%, rgba(10, 132, 71, 0.16) 30.36%, ${p.theme.colors.primary.green100} 57.67%, rgba(10, 132, 71, 0.4) 94.61%)`};
`

export const TableHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;

    border-top: ${(p) => `2px solid ${p.theme.colors.tertiary.tertiary50}`};
    border-bottom: ${(p) => `2px solid ${p.theme.colors.tertiary.tertiary50}`};

    & > [data-hide-on-mobile='true'] {
        ${media.mobile} {
            display: none;
        }
    }

    & > [data-hide-on-tablet='true'] {
        ${media.tablet} {
            display: none;
        }
    }
`

export const TableRow = styled.button<{
    $isOdd: boolean
    $isSelected?: boolean
    $cardLayout?: boolean
}>`
    pointer-events: ${(p) => (p.disabled ? 'none' : 'auto')};
    display: flex;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    border: none;
    padding: 8px 16px;
    margin: 0;
    cursor: pointer;
    box-sizing: border-box;
    text-decoration: none;
    border-radius: 8px;

    color: ${(p) => p.theme.colors.darkGrey};

    background-color: ${(p) =>
        p.$isOdd ? p.theme.colors.tertiary.default : p.theme.colors.white};

    border: 1px solid transparent;

    ${(p) => p.$isSelected && selectedStyle}

    &:hover {
        ${selectedStyle}
    }

    & > div {
        display: flex;
        align-items: start;
        justify-content: space-between;
        text-align: left;
    }

    & > [data-hide-on-mobile='true'] {
        ${media.mobile} {
            display: none;
        }
    }

    & > [data-hide-on-tablet='true'] {
        ${media.tablet} {
            display: none;
        }
    }

    ${(p) =>
        p.$cardLayout &&
        css`
            ${media.mobile} {
                flex-direction: column;
                align-items: flex-start;
                gap: 4px;
                padding: 12px 16px;
                min-height: 44px;

                & > div {
                    width: 100%;
                }
            }
        `}
`
